var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 17.3337C6.7891 17.3356 4.66832 16.4583 3.10509 14.8951C1.54185 13.3318 0.664518 11.2111 0.666507 9.00032V8.83366C0.734664 5.49384 2.78967 2.51712 5.88848 1.26954C8.98728 0.0219592 12.5316 0.744399 14.8948 3.10532C17.2802 5.48872 17.9941 9.07477 16.7035 12.19C15.4128 15.3053 12.3719 17.3356 8.99984 17.3337ZM8.99984 10.1753L11.1582 12.3337L12.3332 11.1587L10.1748 9.00032L12.3332 6.84199L11.1582 5.66699L8.99984 7.82532L6.84151 5.66699L5.66651 6.84199L7.82484 9.00032L5.66651 11.1587L6.84151 12.3337L8.99984 10.1762V10.1753Z",
    fill: "#CA4139"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffClose);
export default __webpack_public_path__ + "static/media/off_close.f5f44363c6869c65068ad2efd665ce30.svg";
export { ForwardRef as ReactComponent };